@if (options().length) {
    <app-form-select [control]="control()" [options]="options()" [label]="'common.print.printer' | translate" inputId="printTarget" />
    <app-button variant="outlined" severity="secondary" [disabled]="busy()" (click)="print.emit()">
        <cl-icon [icon]="icons.Send" />
        {{ submitLabel() }}
    </app-button>
}
